"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.API = exports.client = undefined;

var _APIClient = require("../core/APIClient");

var _app = require("./app");

var _actions = require("../reducers/auth/actions");

var _pngDataURIToBlob = require("../core/pngDataURIToBlob");

var _pngDataURIToBlob2 = _interopRequireDefault(_pngDataURIToBlob);

var _AppUserProfile = require("../../../backend/src/shared/schemas/AppUserProfile");

var _uuid = require("uuid");

var uuid = _interopRequireWildcard(_uuid);

var _BaseAPI2 = require("../BaseAPI");

var _BaseAPI3 = _interopRequireDefault(_BaseAPI2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var client = exports.client = new _APIClient.APIClient(function () {
    return _app.store.getState().auth.accessToken;
}, function () {
    return _app.store.getState().auth.refreshToken;
}, function () {
    return _app.store.getState().auth.isAuthenticated;
}, function (statusCode) {
    return _app.store.dispatch((0, _actions.logoutOnUnauthorizedApiError)({
        payload: {
            status: statusCode
        }
    }));
});

// extends the BaseAPI static class

var API = exports.API = function (_BaseAPI) {
    _inherits(API, _BaseAPI);

    function API() {
        _classCallCheck(this, API);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(API).apply(this, arguments));
    }

    return API;
}(_BaseAPI3.default);

API.getUserProfile = function () {
    return {
        url: "app/v1/user/profile",
        method: "GET",
        schema: _AppUserProfile.AppUserProfile
    };
};
API.getReports = function () {
    return {
        url: "app/v1/reports/contents",
        method: "GET"
    };
};
API.getReport = function (uid) {
    return {
        url: "app/v1/reports/contents/" + uid,
        method: "GET"
    };
};
API.getLatestReportDefinitions = function () {
    return {
        url: "app/v1/reports/definitions/latest",
        method: "GET"
    };
};
API.getReportDefinition = function (uid) {
    return {
        url: "app/v1/reports/definitions/" + uid,
        method: "GET"
    };
};
API.copyReport = function (uid, newTitle) {
    return {
        url: "app/v1/reports/contents/" + uid + "/copy",
        method: "POST",
        parameters: { title: newTitle }
    };
};
API.deleteReport = function (uid) {
    return {
        url: "app/v1/reports/contents/" + uid,
        method: "DELETE"
    };
};
API.getPdfReport = function (uid) {
    return {
        url: "app/v1/reports/contents/" + uid + "/pdf",
        method: "GET",
        headers: {
            "Accept": "Blob/pdf",
            "Content-Type": "application/json"
        }
    };
};
API.createReport = function (name, client, clientFreeText, definitionUid) {
    var clientIsNew = client ? false : true;
    var clientName = client || clientFreeText;
    return {
        url: "app/v2/reports/contents",
        method: "POST",
        parameters: {
            uid: uuid.v4(),
            title: name,
            definitionUid: definitionUid,
            client: {
                isNew: clientIsNew,
                client: clientName
            },
            data: {
                objects: [],
                items: [],
                issues: [],
                typeReferences: [],
                fields: []
            }
        }
    };
};
API.updateReport = function (report) {
    return {
        url: "app/v1/reports/contents/" + report.uid,
        method: "PUT",
        parameters: {
            uid: report.uid,
            title: report.title,
            data: report.data,
            definitionUid: report.definitionUid
        }
    };
};
API.uploadAttachment = function (reportUid, uid, imageBase64Encoded, type) {
    var data = new FormData();
    var dataType = imageBase64Encoded.match(/^data:[a-z]*\/[a-z]*/);
    var blob = void 0;
    if (dataType[0] === "data:application/pdf") {
        blob = (0, _pngDataURIToBlob2.default)(imageBase64Encoded);
        data.append("files", blob, "data.pdf");
    } else {
        blob = (0, _pngDataURIToBlob2.default)(imageBase64Encoded);
        data.append("files", blob, "image.png");
    }
    var query = null;
    switch (type) {
        case "field":
            query = "field=" + uid;
            break;
        case "issue":
            query = "issue=" + uid;
            break;
    }
    return {
        url: "app/v1/reports/contents/" + reportUid + "/attachments?" + query,
        method: "POST",
        parameters: data
    };
};
API.deleteAttachment = function (reportUid, attachmentUid) {
    return {
        url: "app/v1/reports/contents/" + reportUid + "/attachments/" + attachmentUid,
        method: "DELETE"
    };
};
API.closeReport = function (reportUid) {
    return {
        url: "app/v1/reports/contents/" + reportUid + "/close",
        method: "POST"
    };
};
API.reopenReport = function (reportUid) {
    return {
        url: "app/v1/reports/contents/" + reportUid + "/reopen",
        method: "POST"
    };
};
API.approveReport = function (reportUid) {
    return {
        url: "app/v1/reports/contents/" + reportUid + "/approve",
        method: "POST"
    };
};
API.getReportContingent = function (reportDefinitionUid) {
    return {
        url: "app/v1/reports/definitions/" + reportDefinitionUid + "/contingent",
        method: "GET"
    };
};
API.getAllUsersOfCompany = function (userUid) {
    return {
        url: "app/v1/company/users/" + userUid,
        method: "GET"
    };
};
API.saveToSharedWith = function (userId, reportUid) {
    return {
        url: "app/v1/reports/sharedWith/save/" + userId + "/" + reportUid,
        method: "GET"
    };
};
API.removeFromSharedWith = function (reportUid, userId) {
    return {
        url: "app/v1/reports/sharedWith/remove/" + reportUid + "/" + userId,
        method: "GET"
    };
};
API.getUserIdsAndNames = function (userIds) {
    return {
        url: "app/v1/reports/sharedWith/getUserIdsAndNames",
        method: "POST",
        parameters: userIds
    };
};
API.transferReport = function (reportUid, userId) {
    return {
        url: "app/v1/reports/transferReport/" + reportUid + "/" + userId,
        method: "POST"
    };
};
API.getClients = function (userUid) {
    return {
        url: "app/v1/clients/" + userUid,
        method: "GET"
    };
};
API.createClient = function (name, userUid) {
    return {
        url: "app/v1/clients/new/" + userUid + "/" + name,
        method: "POST"
    };
};
API.giveReasonForSendingBackReport = function (reportUid, reason) {
    return {
        url: "app/v1/reports/reopen/" + reportUid,
        method: "POST",
        parameters: {
            reason: reason
        }
    };
};
API.mergeClients = function (fromClientUid, toClientUid) {
    return {
        url: "app/v1/clients/merge/" + fromClientUid + "/" + toClientUid,
        method: "POST"
    };
};
API.changeClientOfReport = function (client, reportUid) {
    return {
        url: "app/v1/report/client/change/" + reportUid,
        method: "POST",
        parameters: {
            client: {
                isNew: client.isNew,
                name: client.name,
                uid: client.uid
            }
        }
    };
};
API.removeClientOfReport = function (reportUid) {
    return {
        method: "DELETE",
        url: "app/v1/client/remove/" + reportUid
    };
};
API.getClientWithReportUid = function (reportUid) {
    return {
        method: "GET",
        url: "app/v1/client/get/" + reportUid
    };
};
API.upgradeReport = function (uid, name, version) {
    return {
        url: "app/v1/reports/contents/" + uid + "/upgrade",
        method: "POST",
        parameters: {
            name: name,
            version: version
        }
    };
};
exports.default = API;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/API.ts
 ** module id = 41
 ** module chunks = 0
 **/